import { render, staticRenderFns } from "./ShiftRegister.vue?vue&type=template&id=380bef88"
import script from "./ShiftRegister.vue?vue&type=script&lang=js"
export * from "./ShiftRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380bef88')) {
      api.createRecord('380bef88', component.options)
    } else {
      api.reload('380bef88', component.options)
    }
    module.hot.accept("./ShiftRegister.vue?vue&type=template&id=380bef88", function () {
      api.rerender('380bef88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/integration/ShiftRegister.vue"
export default component.exports